import { Radar } from 'lucide-react';
import { GetServerSideProps, NextPage } from 'next';
import { ParsedUrlQuery } from 'querystring';

import { GoogleMapsLoader } from '@/components/google-maps-loader';
import { AppLayout } from '@/components/layouts/app-layout';
import { PortInsightsLayout } from '@/components/views/port-insights/layout';
import { PortInsightsSearch } from '@/components/views/port-insights/search';
import { SITE_NAME } from '@/lib/constants';

interface PortSearchPageProps {
  portFromUrlParam?: string | null;
  placeFromUrlParam?: string | null;
}

const Page: NextPage<PortSearchPageProps> = ({ portFromUrlParam, placeFromUrlParam }) => {
  return (
    <AppLayout
      title={`Port Insights - ${SITE_NAME}`}
      breadcrumbItems={[
        { label: 'Port Insights' },
        { label: 'Explore ports', icon: <Radar className="text-lightBlue-500" /> },
      ]}
    >
      <GoogleMapsLoader>
        <div className="flex h-full w-full flex-col">
          <PortInsightsSearch portFromUrlParam={portFromUrlParam} placeFromUrlParam={placeFromUrlParam} />
          <PortInsightsLayout />
        </div>
      </GoogleMapsLoader>
    </AppLayout>
  );
};

export const getServerSideProps: GetServerSideProps<PortSearchPageProps, ParsedUrlQuery> = async ({ query }) => {
  // Get the port and place from the URL query as getting
  // them from the client router can be unreliable
  return {
    props: {
      portFromUrlParam: (query.port as string) || null,
      placeFromUrlParam: (query.place as string) || null,
    },
  };
};

export default Page;
